import type { ProjectViewState } from '@web/lib/projector';

export class RunProjectionStore {
  private readonly projects = new Map<string, ProjectViewState>();
  private readonly listeners = new Map<string, Set<() => void>>();

  getProject(projectId: string): ProjectViewState | null {
    return this.projects.get(projectId) || null;
  }

  getRun(projectId: string, runId: string) {
    return this.projects.get(projectId)?.runs[runId] || null;
  }

  replaceProject(state: ProjectViewState): void {
    if (this.projects.get(state.projectId) === state) return;
    this.projects.set(state.projectId, state);
    for (const listener of [...(this.listeners.get(state.projectId) || [])]) {
      try {
        listener();
      } catch (error) {
        console.error('[RunProjectionStore] subscriber failed', error);
      }
    }
  }

  subscribeProject(projectId: string, listener: () => void): () => void {
    let listeners = this.listeners.get(projectId);
    if (!listeners) {
      listeners = new Set();
      this.listeners.set(projectId, listeners);
    }
    listeners.add(listener);
    return () => {
      listeners?.delete(listener);
      if (listeners?.size === 0) this.listeners.delete(projectId);
    };
  }

  clearProject(projectId: string): void {
    if (!this.projects.delete(projectId)) return;
    this.emit(projectId);
  }

  clear(): void {
    const projectIds = [...this.projects.keys()];
    this.projects.clear();
    projectIds.forEach((projectId) => this.emit(projectId));
  }

  private emit(projectId: string): void {
    for (const listener of [...(this.listeners.get(projectId) || [])]) {
      try {
        listener();
      } catch (error) {
        console.error('[RunProjectionStore] subscriber failed', error);
      }
    }
  }
}

export const runProjectionStore = new RunProjectionStore();
